import { Navigate, useLocation } from "react-router-dom";
import { CITIES } from "@/data/cities";
import NotFound from "@/pages/NotFound";

// Anciennes pages de l'ancien site encore indexées par Google -> nouvelles pages
const EXACT_REDIRECTS = {
    "/nuisibles": "/",
    "/puces": "/",
    "/traitement-par-vapeur": "/protocole-punaises",
    "/traitement-chimique": "/protocole-punaises",
    "/blog": "/",
};

const NEW_ROUTES = new Set([
    "/",
    "/punaises-de-lit",
    "/zone-intervention",
    "/cafards",
    "/tarifs",
    "/protocole-punaises",
    "/protocole-cafards",
    "/mentions-legales",
    "/politique-confidentialite",
    "/cgv",
    "/contact",
    "/pros",
]);

const squash = (s) =>
    s
        .toLowerCase()
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .replace(/[^a-z0-9]/g, "");

const CITY_BY_SQUASH = new Map(CITIES.map((c) => [squash(c.slug), c.slug]));

// Retrouve une ville à partir du préfixe des anciennes URL (ex: "stmalo", "st-coulomb", "rennes")
const findCitySlug = (prefix) => {
    const p = squash(prefix);
    if (CITY_BY_SQUASH.has(p)) return CITY_BY_SQUASH.get(p);
    if (p.startsWith("ste")) {
        const q = `sainte${p.slice(3)}`;
        if (CITY_BY_SQUASH.has(q)) return CITY_BY_SQUASH.get(q);
    }
    if (p.startsWith("st")) {
        const q = `saint${p.slice(2)}`;
        if (CITY_BY_SQUASH.has(q)) return CITY_BY_SQUASH.get(q);
    }
    return null;
};

const LegacyRedirect = () => {
    const { pathname } = useLocation();
    const path = (pathname.toLowerCase().replace(/\/+$/, "") || "/");

    if (EXACT_REDIRECTS[path]) {
        return <Navigate to={EXACT_REDIRECTS[path]} replace />;
    }

    // Slash final en trop sur une page existante (ex: /tarifs/)
    if (path !== pathname.toLowerCase() && NEW_ROUTES.has(path)) {
        return <Navigate to={path} replace />;
    }

    // Anciennes fiches villes : /ville-punaisesdelit et /ville-desinsectisation
    for (const suffix of ["-punaisesdelit", "-desinsectisation"]) {
        if (path.endsWith(suffix)) {
            const slug = findCitySlug(path.slice(0, -suffix.length));
            return <Navigate to={slug ? `/punaises-de-lit/${slug}` : "/punaises-de-lit"} replace />;
        }
    }

    return <NotFound />;
};

export default LegacyRedirect;
